<template>
  <div id="app">
    <h2 class="title">Что бы сделать сегодня?</h2>

    <form @submit.prevent="addTask">
      <input type="text" v-model="taskItem" placeholder="Что там по делам?" />
      <button class = "btnAddTask" @click = "addTask">Add</button>
    </form>

    <task
      v-for="(task, index) in tasks"
      :key="index"
      :task="task"
      :taskIndex="index"
      @changeStatus="changeStatus"
      @removeTask="removeTask"
    />


    <button class="btnRemoveAll" @click="removeAll">Remove All</button>
  </div>
</template>

<script>
import task from "./components/task.vue";

export default {
  components: {
    task
  },
  data() {
    return {
      tasks: [
        { name: "Поесть", status: false },
        { name: "Поспать", status: false }
      ],
      taskItem: ""
    };
  },

  methods: {
    
    addTask() {
      if (this.taskItem) {
        this.tasks.push({ name: this.taskItem, status: false });
        this.taskItem = "";
      }
    },

    removeAll() {
      this.tasks = []; 
    },

    changeStatus(data) {
      this.tasks[data.index].status = data.status;
    },

    removeTask(index) {
      this.tasks.splice(index, 1);
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.btnRemoveAll {
  margin-top: 10px;
}

.btnAddTask {
  margin-left: 20px;
}
</style>
